export type I18nLanguageSource = {
  resolvedLanguage?: string;
  language: string;
};

// `language` is the requested tag; `resolvedLanguage` is the one i18next actually loaded.
export const resolveI18nLanguage = ({
  resolvedLanguage,
  language,
}: I18nLanguageSource): string => resolvedLanguage ?? language;
